import { render, staticRenderFns } from "./vip-company-list.vue?vue&type=template&id=ee0bb97a"
import script from "./vip-company-list.vue?vue&type=script&lang=js"
export * from "./vip-company-list.vue?vue&type=script&lang=js"
import style0 from "./vip-company-list.vue?vue&type=style&index=0&id=ee0bb97a&prod&lang=less&scope=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports